import { LoadFileDurationRef, LoadFileStepRef, LoadFileTypeRef, LoadFileUnitRef } from './LoadReference';
import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class LoadFile {

  public static build(
    typeRef: LoadFileTypeRef,
    durationRef: LoadFileDurationRef,
    stepRef: LoadFileStepRef,
    unitRef: LoadFileUnitRef,
    content: string): LoadFile {
    const file: LoadFile = new LoadFile();
    file.typeRef = typeRef;
    file.durationRef = durationRef;
    file.stepRef = stepRef;
    file.unitRef = unitRef;
    file.originalContent = content;
    return file;
  }

  public typeRef: LoadFileTypeRef | null = null;

  public durationRef: LoadFileDurationRef | null = null;

  public unitRef: LoadFileUnitRef | null = null;

  public stepRef: LoadFileStepRef | null = null;

  public startDate: Date | null = null;

  public correctionCoefficient: number | null = null;

  public name: string | null = null;

  public originalContent: string | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);

    this.typeRef = this.typeRef ? (LoadFileTypeRef as any)[this.typeRef] : null;

    this.durationRef = this.durationRef ? (LoadFileDurationRef as any)[this.durationRef] : null;

    this.unitRef = this.unitRef ? (LoadFileUnitRef as any)[this.unitRef] : null;

    this.stepRef = this.stepRef ? (LoadFileStepRef as any)[this.stepRef] : null;
  }
}
